import React, { Component } from "react";
import { Box } from "reflexbox";
import { connect } from "react-redux";
import { toggleForm } from "../../actions/ui_actions";
import ToggleForm from "../../common/Buttons/_ToggleForm";

import { selectRelation, selectContact } from "../../actions/select_actions";

import { HoverCard } from "office-ui-fabric-react/lib/HoverCard";
import { DirectionalHint } from "office-ui-fabric-react/lib/common/DirectionalHint";
import { DefaultButton } from "office-ui-fabric-react/lib/Button";

class RelationHoverCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contentRendered: undefined
    };
  }

  _onRenderCompactCard = relation => {
    return (
      <Box m={1}>
        <h3>{relation.name}</h3>
      </Box>
    );
  };

  _onRenderExpandedCard = relation => {
    this.props.selectRelation(relation);
    return (
      <Box m={1}>
        <Box>
          <Box>
            Loading adres: {relation.loadingAddr}
            <br />
            Loading route: {relation.loadingRoute}
            <br />
            Door code: {relation.doorCode}
            <br />
          </Box>
          <Box mt={3}>
            <ToggleForm form="relation" addOrEdit="edit" />
          </Box>
        </Box>
        <Box>
          <Box>
            <table>
              <thead>
                <tr>
                  <td>Name</td>
                  <td>Department</td>
                  <td>Tel work</td>
                  <td>Mobile</td>
                </tr>
              </thead>
              <tbody>
                {relation.contactsByRelationId.nodes.length > 0 &&
                  relation.contactsByRelationId.nodes.map(contact => (
                    <tr key={contact.id}>
                      <td>{contact.name}</td>
                      <td>{contact.department}</td>
                      <td>{contact.telWork}</td>
                      <td>{contact.telMobile}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </Box>
          <Box mt={3}>
            {/* <DefaultButton
              onClick={e => {
                e.preventDefault();
                this.handleClickContact(relation);
              }}
            >
              Edit
            </DefaultButton> */}
          </Box>
        </Box>
      </Box>
    );
  };

  render() {
    const expandingCardProps = {
      compactCardHeight: "50",
      expandedCardHeight: "400",
      onRenderCompactCard: this._onRenderCompactCard,
      onRenderExpandedCard: this._onRenderExpandedCard,
      renderData: this.props.relation,
      directionalHint: DirectionalHint.rightTopEdge,
      gapSpace: 6
    };

    return (
      <div
        ref={c =>
          !this.state.contentRendered && this.setState({ contentRendered: c })
        }
        data-is-focusable={true}
      >
        {this.props.relation && this.props.relation.code}
        {this.state.contentRendered && (
          <HoverCard
            expandingCardProps={expandingCardProps}
            target={this.state.contentRendered}
            cardOpenDelay={500}
            expandedCardOpenDelay={1000}
            cardDismissDelay={300}
            trapFocus={false}
          />
        )}
      </div>
    );
  }
}

export default connect(null, {
  toggleForm: toggleForm,
  selectRelation: selectRelation,
  selectContact: selectContact
})(RelationHoverCard);



// WEBPACK FOOTER //
// ./src/views/Relations/_RelationHoverCard.js